import gql from 'graphql-tag';

export const SaveAnnotationMutation = gql`
  mutation ($annotationInput: AnnotationInput!) {
    saveAnnotation (annotation: $annotationInput)
    {
      id
      _Objectid_Value
      objectTypeCode
      fileName
      fileSize
      mimeType
      subject
      noteText
      documentBody
    }
  }
`;

export const DeleteAnnotationMutation = gql`
  mutation ($annotationId: String,$applicationId:String) {
    deleteAnnotation (annotationId: $annotationId,applicationId: $applicationId)
    {
      id
    }
  }
`;

